import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import AddIcon from "@mui/icons-material/Add";
import { CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getRegisteredUnemployedPeople } from "../../store/unemployed-people/actions";
import { connect } from "react-redux";
import {
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

import { CardContent, Toolbar } from "@mui/material";
import MenuBar from "../structure/components/MenuBar";
import SearchBox from "../common/components/SearchBox";
import { CSVLink } from "react-csv";
import TableSkeleton from "../common/components/TableSkeleton";
import BackdropLoader from "../common/components/BackdropLoader";
import ReactPaginate from "react-paginate";
import NumberFormat from "react-number-format";
import CurrencyFormat from "react-currency-format";

// import { useRequiredAuth } from "../common/hooks/useRequiredAuth";

const UnemployedPeople = (props) => {
  useEffect(() => {
    document.title = "IPPIS - Registered Unemployed People";
  });

  const {
    user,
    loading,
    registeredUnemployedPeople,
    getRegisteredUnemployedPeople,
  } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(100);
  const [loader, setLoader] = useState(false);
  const [onNextPage, setOnNextPage] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };
    getRegisteredUnemployedPeople(query, setTotalItems, setLoader);
  }, []);

  const theme = useTheme();

  const onSearch = () => {
    if (!searchTerm) return false;
    const currentPage = 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getRegisteredUnemployedPeople(query, setTotalItems, setLoader);
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };
    getRegisteredUnemployedPeople(query, setTotalItems, setOnNextPage);
  };

  // const { hasPermissions } = useRequiredAuth();
  // const downloadExcelFile = async () => {
  //   if (!!registeredUnemployedPeople.length)
  //     document.getElementById("downloadBTN").click();
  // };

  const downloadExcelFile = async () => {
    if (!registeredUnemployedPeople.length) return;
    setLoader(true);
    try {
      const allDataQuery = {
        searchTerm: searchTerm,
        page: 1,
        size: totalItems || 100000,
      };
      let allRecords = [];
      await getRegisteredUnemployedPeople(
        allDataQuery,
        (total) => {
          setTotalItems(total);
        },
        () => {},
        (data) => {
          allRecords = data;
        },
      );
      document.getElementById("downloadBTN").click();
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="py-1 d-flex flex-wrap justify-content-between mt-0  align-items-center px-4"
        style={{
          backgroundColor: "#078ece",
          borderBottom: "1px solid #078ece",
          borderTop: "1px solid #078ece",
        }}
      ></div>

      <Box sx={{ display: "flex", width: "100%" }}>
        <div className="w-100">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar className="d-flex flex-wrap justify-content-between mt-2">
              <Typography
                className="d-flex align-items-center flex-wrap"
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span className="text-uppercase">
                  Registered Unemployed People (
                  <CurrencyFormat
                    value={totalItems}
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  )
                </span>
                <span>
                  <CSVLink
                    data={registeredUnemployedPeople}
                    filename={`Registered Unemployed People.csv`}
                    className="hidden"
                    id="downloadBTN"
                    target="_blank"
                  />
                  <Button
                    disabled={
                      loading ||
                      !registeredUnemployedPeople.length ||
                      onNextPage ||
                      loader
                    }
                    className="ml-2"
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      downloadExcelFile();
                    }}
                  >
                    {loader ? (
                      <>
                        <CircularProgress
                          size={18}
                          thickness={5}
                          style={{ color: "white", marginRight: 6 }}
                        />
                        Downloading...
                      </>
                    ) : (
                      <>
                        <span className="material-icons">download</span>
                        Download (.csv) File
                      </>
                    )}
                  </Button>
                </span>
              </Typography>

              <div className="d-flex flex-wrap justify-content-end align-items-center pl-2">
                <SearchBox
                  disabled={!registeredUnemployedPeople.length || onNextPage}
                  onSearch={onSearch}
                  placeholder="Search…"
                />
              </div>
            </Toolbar>
          </AppBar>

          <div
            style={{
              padding: theme.spacing(0.4),
              height: "auto",
              maxHeight: "auto",
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              overflow: "visible",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            }}
          >
            <CardContent
              className="py-0"
              style={{
                height: "auto",
                maxHeight: "63vh",
                minHeight: "auto",
                overflow: "auto",
              }}
            >
              <table className=" table-striped table-sm fixTableHead">
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="px-1">Names</th>
                    <th className="px-1">NID Number</th>
                    <th className="px-1">Sex</th>
                    <th className="px-1">Age</th>
                    <th className="px-1">Phone Number</th>
                    <th className="px-1">Province</th>
                    <th className="px-1">District</th>
                    <th className="px-1">Sector</th>
                    <th className="px-1">Cell</th>
                    <th className="px-1">Village</th>
                    <th className="px-1">Rural/Urban</th>
                    <th className="px-1"></th>
                  </tr>
                </thead>

                {loader ? (
                  <TableSkeleton cols={13} rows={15} />
                ) : (
                  <tbody>
                    {!!onNextPage && (
                      <tr>
                        <td colSpan={13}>
                          <BackdropLoader isLoading={onNextPage} />
                        </td>
                      </tr>
                    )}

                    {registeredUnemployedPeople.map((item) => (
                      <ItemCard key={item.id} item={item} />
                    ))}
                  </tbody>
                )}
              </table>
              <div
                className="d-flex justify-content-center  align-items-start pt-2"
                style={{ overflow: "hidden" }}
              >
                <div>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    // marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalItems / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-info btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                {!!registeredUnemployedPeople.length && (
                  <select
                    className="custom-select custom-select-sm ml-2"
                    style={{ width: "100px" }}
                    value={itemPerPage}
                    onChange={(event) => {
                      const itemPerPage = +event.target.value;
                      window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                      setItemPerPage(itemPerPage);
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };
                      getRegisteredUnemployedPeople(
                        query,
                        setTotalItems,
                        setOnNextPage,
                      );
                    }}
                  >
                    {[100, 200, 300, 400, 500].map((item, index) => (
                      <option key={index}>{item}</option>
                    ))}
                  </select>
                )}
              </div>
            </CardContent>
          </div>
        </div>
      </Box>
    </>
  );
};

const mapStateToProps = ({ user, loading, registeredUnemployedPeople }) => {
  return {
    user,
    loading,
    registeredUnemployedPeople,
  };
};

export default connect(mapStateToProps, {
  getRegisteredUnemployedPeople,
})(UnemployedPeople);

const ItemCard = (props) => {
  const { item } = props;

  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      <tr>
        <td>{item.no}</td>
        <td className="px-1">{item.names}</td>
        <td className="px-1">{item.id_number}</td>
        <td className="px-1">{item.sex}</td>
        <td className="px-1">{item.age}</td>
        <td className="px-1">{item.phone_number}</td>
        <td className="px-1">{item.province}</td>
        <td className="px-1">{item.district}</td>
        <td className="px-1">{item.sector}</td>
        <td className="px-1">{item.cell}</td>
        <td className="px-1">{item.village}</td>
        <td className="px-1">{item.rural_urban}</td>
        <td className="px-1 text-right">
          <button
            onClick={() => setShowPreview(true)}
            className="btn btn-sm btn-primary"
          >
            Preview
          </button>
        </td>
      </tr>

      {showPreview && (
        <PreviewItem
          item={item}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
        />
      )}
    </>
  );
};

const PreviewItem = (props) => {
  const { showPreview, setShowPreview, item } = props;

  return (
    <Dialog
      onClose={() => setShowPreview(false)}
      open={showPreview}
      fullWidth
      maxWidth={`xl`}
    >
      <DialogTitle>
        <Typography className="text-primary text-uppercase">
          <span className="d-flex align-items-center">
            <span>Preview | {item.names}</span>
          </span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={() => setShowPreview(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>

      <DialogContent className="mx-4 px-2">
        <div
          style={{
            minHeight: "70vh",
          }}
          // className="border rounded bg-light"
        >
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th colSpan={2}>Personnel Identification</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{item.names}</td>
              </tr>
              <tr>
                <td>ID Number</td>
                <td>{item.id_number}</td>
              </tr>
              <tr>
                <td>Sex</td>
                <td>{item.sex}</td>
              </tr>
              <tr>
                <td>Date Of Birth</td>
                <td>{item.dob}</td>
              </tr>
              <tr>
                <td>Age</td>
                <td>{item.age}</td>
              </tr>
              <tr>
                <td>Phone Number</td>
                <td>{item.phone_number}</td>
              </tr>
              <tr>
                <td>Province</td>
                <td>{item.province}</td>
              </tr>
              <tr>
                <td>District</td>
                <td>{item.district}</td>
              </tr>
              <tr>
                <td>Sector</td>
                <td>{item.sector}</td>
              </tr>
              <tr>
                <td>Cell</td>
                <td>{item.cell}</td>
              </tr>
              <tr>
                <td>Village</td>
                <td>{item.village}</td>
              </tr>
              <tr>
                <td>Rural/Urban</td>
                <td>{item.rural_urban}</td>
              </tr>
            </tbody>
          </table>

          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th colSpan={2}>Questionnaire</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Q1: Currently student</td>
                <td className={`${!item.q1 ? "bg-warning-light" : ""}`}>
                  {item.q1}
                </td>
              </tr>
              <tr>
                <td>Q2: Level of education attended</td>
                <td className={`${!item.q2 ? "bg-warning-light" : ""}`}>
                  {item.q2}
                </td>
              </tr>
              <tr>
                <td>Q3: Whether the level was completed</td>
                <td className={`${!item.q3 ? "bg-warning-light" : ""}`}>
                  {item.q3}
                </td>
              </tr>
              <tr>
                <td>Q4: Field of education</td>
                <td className={`${!item.q4 ? "bg-warning-light" : ""}`}>
                  {item.q4}
                </td>
              </tr>
              <tr>
                <td>Q5: Currently attending technical trades</td>
                <td className={`${!item.q5 ? "bg-warning-light" : ""}`}>
                  {item.q5}
                </td>
              </tr>
              <tr>
                <td>Q6: Previously attended technical trades</td>
                <td className={`${!item.q6 ? "bg-warning-light" : ""}`}>
                  {item.q6}
                </td>
              </tr>
              <tr>
                <td>Q7: Technical trades attending or attended</td>
                <td className={`${!item.q7 ? "bg-warning-light" : ""}`}>
                  {item.q7}
                </td>
              </tr>
              <tr>
                <td>Q8: Willing to attend technical trade</td>
                <td className={`${!item.q8 ? "bg-warning-light" : ""}`}>
                  {item.q8}
                </td>
              </tr>
              <tr>
                <td>Q9: Technical trades willing to attend</td>
                <td className={`${!item.q9 ? "bg-warning-light" : ""}`}>
                  {item.q9}
                </td>
              </tr>
              <tr>
                <td>Q10: Currently employed</td>
                <td className={`${!item.q10 ? "bg-warning-light" : ""}`}>
                  {item.q10}
                </td>
              </tr>
              <tr>
                <td>Q11: Participating in subsistence agriculture</td>
                <td className={`${!item.q11 ? "bg-warning-light" : ""}`}>
                  {item.q11}
                </td>
              </tr>
              <tr>
                <td>
                  Q12: Period of not working and actively looking for work
                </td>
                <td className={`${!item.q12 ? "bg-warning-light" : ""}`}>
                  {item.q12}
                </td>
              </tr>
              <tr>
                <td>Q13: Willing to work if opportunities arise</td>
                <td className={`${!item.q13 ? "bg-warning-light" : ""}`}>
                  {item.q13}
                </td>
              </tr>
              <tr>
                <td>Q14: Location of work if opportunities arise</td>
                <td className={`${!item.q14 ? "bg-warning-light" : ""}`}>
                  {item.q14}
                </td>
              </tr>
              <tr>
                <td>Q15: Sectors of employment if opportunities arise</td>
                <td className={`${!item.q15c ? "bg-warning-light" : ""}`}>
                  {/* {item.q15c} */}

                  <FormGroup
                    className="ml-2"
                    // row
                    // style={{
                    //   backgroundColor: "#e9ecef",
                    //   border: "1px solid #cfd3d8",
                    // }}
                  >
                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_A === "Yes"}
                        />
                      }
                      label="Ubuhinzi bworozi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_B === "Yes"}
                        />
                      }
                      label="Ubwubatsi bw'imihanda"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_C === "Yes"}
                        />
                      }
                      label="Gutunganya ibishanga"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_D === "Yes"}
                        />
                      }
                      label="Gukora amaterasi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_E === "Yes"}
                        />
                      }
                      label="Amashyamba n'ibidukikije"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_F === "Yes"}
                        />
                      }
                      label="Gucukura amabuye y'agaciro"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_G === "Yes"}
                        />
                      }
                      label="Inganda"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_H === "Yes"}
                        />
                      }
                      label="Amashanyarazi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_I === "Yes"}
                        />
                      }
                      label="Amazi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_J === "Yes"}
                        />
                      }
                      label="Ubucuruzi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_K === "Yes"}
                        />
                      }
                      label="Ubwubatsi bw'amazu"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_L === "Yes"}
                        />
                      }
                      label="Gutwara abantu n'ibintu"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_M === "Yes"}
                        />
                      }
                      label="Ibijyanye n'amacumbi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_N === "Yes"}
                        />
                      }
                      label="Imirimoy'ubunyamwuga na tekiniki"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_O === "Yes"}
                        />
                      }
                      label="Uburezi"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_P === "Yes"}
                        />
                      }
                      label="Ubuzima"
                    />

                    <FormControlLabel
                      className="mb-0"
                      control={
                        <Checkbox
                          className="p-0"
                          size="small"
                          readOnly
                          checked={item.q15_ZZ === "Yes"}
                        />
                      }
                      label="Others"
                    />
                  </FormGroup>
                </td>
              </tr>
              {/* <tr>
                <td>Q15_A: Ubuhinzi bworozi</td>
                <td>{item.q15_A}</td>
              </tr>
              <tr>
                <td>Q15_B: Ubwubatsi bw'imihanda</td>
                <td>{item.q15_B}</td>
              </tr>
              <tr>
                <td>Q15_C: Gutunganya ibishanga</td>
                <td>{item.q15_C}</td>
              </tr>
              <tr>
                <td>Q15_D: Ubwubatsi bw'imihanda</td>
                <td>{item.q15_D}</td>
              </tr>
              <tr>
                <td>Q15_E: Amashyamba n'ibidukikije</td>
                <td>{item.q15_E}</td>
              </tr>
              <tr>
                <td>Q15_F: Gucukura amabuye y'agaciro</td>
                <td>{item.q15_F}</td>
              </tr>
              <tr>
                <td>Q15_G: Inganda</td>
                <td>{item.q15_G}</td>
              </tr>
              <tr>
                <td>Q15_H: Amashanyarazi</td>
                <td>{item.q15_H}</td>
              </tr>
              <tr>
                <td>Q15_I: Amazi</td>
                <td>{item.q15_I}</td>
              </tr>
              <tr>
                <td>Q15_J: Ubucuruzi</td>
                <td>{item.q15_J}</td>
              </tr>
              <tr>
                <td>Q15_K: Ubwubatsi bw'amazu</td>
                <td>{item.q15_K}</td>
              </tr>
              <tr>
                <td>Q15_L: Gutwara abantu n'ibintu</td>
                <td>{item.q15_L}</td>
              </tr>
              <tr>
                <td>Q15_M: Ibijyanye n'amacumbi</td>
                <td>{item.q15_M}</td>
              </tr>
              <tr>
                <td>Q15_N: Imirimoy'ubunyamwuga na tekiniki</td>
                <td>{item.q15_N}</td>
              </tr>
              <tr>
                <td>Q15_O: Uburezi</td>
                <td>{item.q15_O}</td>
              </tr>
              <tr>
                <td>Q15_P: Ubuzima</td>
                <td>{item.q15_P}</td>
              </tr>
              <tr>
                <td>Q15_ZZ: Others</td>
                <td>{item.q15_ZZ}</td>
              </tr> */}
              <tr>
                <td>Q16: Reason not willing to work</td>
                <td className={`${!item.q16 ? "bg-warning-light" : ""}`}>
                  {item.q16}
                </td>
              </tr>
              <tr>
                <td>Q17: Have disability</td>
                <td className={`${!item.q17 ? "bg-warning-light" : ""}`}>
                  {item.q17}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center py-4"></DialogActions>
    </Dialog>
  );
};
